import React from "react";
import HomeWelcomeView from './HomeWelcomeView';
import HomeContentView from './HomeContentView';
import HomeGoalsView from './HomeGoalsView';
import HomeTeamView from './HomeTeamView';
import FooterView from '../../components/FooterView';
import HeaderView from '../../components/HeaderView';

const HomePage = () => {
    return (
        <div className="container">
            <HeaderView />
            <HomeWelcomeView />
            <HomeContentView />
            <HomeGoalsView />
            <HomeTeamView />
            <FooterView />
        </div>
    );
};

export default HomePage;
